/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * The version of the OpenAPI document: Latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
/**
 *
 * @export
 * @interface SubOrderLite
 */
export interface SubOrderLite {
  /**
   *
   * @type {number}
   * @memberof SubOrderLite
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof SubOrderLite
   */
  packageCode: string;
  /**
   *
   * @type {number}
   * @memberof SubOrderLite
   */
  grp?: number;
  /**
   *
   * @type {number}
   * @memberof SubOrderLite
   */
  budget?: number;
  /**
   *
   * @type {number}
   * @memberof SubOrderLite
   */
  targetGroupIndex?: number;
  /**
   *
   * @type {Date}
   * @memberof SubOrderLite
   */
  from?: Date;
  /**
   *
   * @type {Date}
   * @memberof SubOrderLite
   */
  to?: Date;
  /**
   *
   * @type {number}
   * @memberof SubOrderLite
   */
  spotLength?: number;
  /**
   *
   * @type {number}
   * @memberof SubOrderLite
   */
  spotsPerDayChannel?: number;
  /**
   *
   * @type {number}
   * @memberof SubOrderLite
   */
  spotsTotal?: number | null;
}

export function SubOrderLiteFromJSON(json: any): SubOrderLite {
  return SubOrderLiteFromJSONTyped(json, false);
}

export function SubOrderLiteFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SubOrderLite {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: !exists(json, "id") ? undefined : json["id"],
    packageCode: json["packageCode"],
    grp: !exists(json, "grp") ? undefined : json["grp"],
    budget: !exists(json, "budget") ? undefined : json["budget"],
    targetGroupIndex: !exists(json, "targetGroupIndex")
      ? undefined
      : json["targetGroupIndex"],
    from: !exists(json, "from") ? undefined : new Date(json["from"]),
    to: !exists(json, "to") ? undefined : new Date(json["to"]),
    spotLength: !exists(json, "spotLength") ? undefined : json["spotLength"],
    spotsPerDayChannel: !exists(json, "spotsPerDayChannel")
      ? undefined
      : json["spotsPerDayChannel"],
    spotsTotal: !exists(json, "spotsTotal") ? undefined : json["spotsTotal"],
  };
}

export function SubOrderLiteToJSON(value?: SubOrderLite | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    packageCode: value.packageCode,
    grp: value.grp,
    budget: value.budget,
    targetGroupIndex: value.targetGroupIndex,
    from: value.from === undefined ? undefined : value.from.toISOString(),
    to: value.to === undefined ? undefined : value.to.toISOString(),
    spotLength: value.spotLength,
    spotsPerDayChannel: value.spotsPerDayChannel,
    spotsTotal: value.spotsTotal,
  };
}
